import { render, staticRenderFns } from "./PATasks.vue?vue&type=template&id=59126c66&scoped=true"
import script from "./PATasks.vue?vue&type=script&lang=js"
export * from "./PATasks.vue?vue&type=script&lang=js"
import style0 from "./PATasks.vue?vue&type=style&index=0&id=59126c66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59126c66",
  null
  
)

export default component.exports